<template>
    <div class="crud-wrapper">
        <div class="box-filters">
            <a-select-field ref="refCovenant" class="filter-covenant" label="Convênio" obj="covenant" v-model="covenantId" validate="required"></a-select-field>
            <a-select-field ref="refBank" class="filter-banks" clearable label="Bancos" obj="bank" v-model="bankId" validate="required"></a-select-field>
            <a-select-field ref="refTerms" class="filter-terms" clearable label="Prazo" :suggestions="terms" v-model="term" validate="required"></a-select-field>
            <v-btn v-on:click="openDialogTable()" style="height: 50px; border-radius: 8px;">Cadastrar</v-btn>
        </div>
        <a-data-grid :columns="headers" height="400" :data="items" @onRowClick="showDetails"></a-data-grid>
        <v-dialog v-model="dialog" width="500">
            <v-card flat>
                <v-card-title>
                  <span class="headline">Coeficiente de Hoje</span>
                </v-card-title>

                <v-form autocomplete="nope" lazy-validation>
                    <v-container grid-list-md>
                    <v-layout wrap>
                        <a-text-field autofocus v-mask="['#,#########']" label="Coeficiente" v-model="todayFactor"></a-text-field>
                    </v-layout>
                    </v-container>
                </v-form>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="dialog = false">
                        Fechar
                    </v-btn>
                    <v-btn color="blue darken-1" flat @click="dialog = false; saveDetails();">
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogTable" width="500">
            <v-card flat>
                <v-card-title>
                  <span class="headline">{{ newTable ? "Cadastrar" : "Alterar" }} Tabela</span>
                </v-card-title>

                <v-form autocomplete="nope" lazy-validation>
                    <v-container grid-list-md>
                        <v-layout class="btn-option-group" row>
                            <div class="btn-option mr-1" :style="!newTable ? 'background-color: #4f4f4f; color: white;' : 'background-color: #EFEFEF; color: #4f4f4f;'" @click="newTable = !newTable;">Tabela Existente</div>
                            <div class="btn-option ml-1" :style="newTable ? 'background-color: #4f4f4f; color: white;' : 'background-color: #EFEFEF; color: #4f4f4f;'" @click="newTable = !newTable;">Nova Tabela</div>
                        </v-layout>    
                        <v-layout column>
                            <a-select-field v-if="dialogTable && !newTable" label="Nome da Tabela" :filter-by="{bankId: this.bankId}" obj="bankChart" v-model="formData.bankChartId" validate="required" ></a-select-field>
                            <a-text-field v-else label="Nome da Tabela" validate="required" v-model="formData.name"></a-text-field>
                            <a-text-field v-if="newTable" label="Código da Tabela" v-model="formData.code"></a-text-field>
                        </v-layout>
                        <v-layout row>
                            <a-text-field v-mask="['#,#########']" label="Juros" v-model="formData.interest"></a-text-field>
                            <a-text-field v-mask="['#,#########']" label="CET" v-model="formData.cet"></a-text-field>
                        </v-layout>
                        <label v-if="formData.todayFactor">Gera parcela de {{ (1000 * parseFloat(formData.todayFactor.replace(',', '.'))) | fmtMoney }} para R$ 1000,00</label>
                        <a-text-field v-mask="['#,#########']" label="Coeficiente de Hoje" v-model="formData.todayFactor"></a-text-field>
                    </v-container>
                </v-form>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="dialogTable = false">
                        Fechar
                    </v-btn>
                    <v-btn color="blue darken-1" flat @click="createNewBankChart()">
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import PageClass from "@consigmais-team/vue-common/layout/defaultPage/pageClass";
    import moment from 'moment';
    import numeral from 'numeral';
    
    export default {
        name: 'TodayFactors',
        components: { VuePerfectScrollbar },
        data: () => ({
            bankId: null,
            covenantId: 1,
            term: null,
            dialog: false,
            dialogTable: false,
            selectedId: null,
            todayFactor: '',
            newTable: false,

            formData: {
                bankChartId: null,
                name: null,
                code: null,
                interest: null,
                cet: null,
                factor: null
            },

            headers: [
                { caption: 'Banco', dataField: 'bankName', minWidth: 120 },
                {
                    caption: 'Tabela de Coeficientes',
                    alignment: 'center',
                    columns: [
                        { caption: 'Código', dataField: 'code', width: 75 },
                        { caption: 'Nome', dataField: 'name', minWidth: 120 },
                        { caption: 'Prazo', dataField: 'term', width: 60 },
                        { 
                            caption: 'Juros', 
                            dataField: 'interest', 
                            width: 100,
                            customizeText: function (data) {
                                return `${numeral(parseFloat(data.value)).format('0,0.000')}%`
                            },
                        },
                        { 
                            caption: 'CET', 
                            dataField: 'cet', 
                            width: 100, 
                            customizeText: function (data) {
                                return `${numeral(parseFloat(data.value)).format('0,0.000')}%`
                            },
                        },
                    ]
                },
                {
                    caption: 'Mais Recentes',
                    alignment: 'center',
                    columns: [
                        { caption: 'Coeficiente', dataField: 'factor', width: 120 },
                        { caption: 'Dia', dataField: 'day', dataType: 'date', format: 'dd/MM/yyyy', width: 100 },
                    ]
                },
                { caption: 'Coeficiente de Hoje', dataField: 'todayFactor', minWidth: 120 },
            ],
            terms: [
                96,
                84,
                72,
                60,
                48
            ],
            factors: [],
            items: [],
        }),

        methods: {
            async createNewBankChart(){
                let newItem = Object({
                    bankChartTerms: Object({
                        term: this.term,
                        factor: parseFloat(this.formData.todayFactor.toString().replace(',', '.')),
                        interest: parseFloat(this.formData.interest.toString().replace(',', '.')),
                        cet: parseFloat(this.formData.cet.toString().replace(',', '.'))
                    }),
                    bankChartDetails: Object({
                        day: moment().format('YYYY-MM-DD'),
                        factor: parseFloat(this.formData.todayFactor.toString().replace(',', '.')),
                    })
                });
                if(this.newTable){
                    newItem.bankChart = Object({
                        bankId: this.bankId,
                        covenantId: this.covenantId,
                        code: this.formData.code,
                        name: this.formData.name,
                    });
                }else{
                    newItem.bankChart = Object({
                        id: this.formData.bankChartId,
                    });
                }
                try{
                    await this.$api.dataService.execute('bankChart/createChart', newItem);
                    this.refreshTerms();
                    this.$notifyUser({
                        message: 'Tabela e Coeficiente cadastrado!'
                    });
                    this.dialogTable = false;
                }
                catch(err){
                    this.$notifyUser({
                        type: 'error',
                        message: 'Não foi possível cadastrar o coeficiente!'
                    });
                }
            },
            openDialogTable() {
                if (this.$refs.refCovenant.forceValidation() && this.$refs.refBank.forceValidation() && this.$refs.refTerms.forceValidation()) {
                    this.dialogTable = true;
                } else {
                    this.$notifyUser({
                        type: 'error',
                        message: 'Preencha os campos Bancos e Prazo!'
                    });
                }
            },
            async refreshTerms() {
                let res = await this.$api.dataService.getData('bankChart/getTodayFactors');
                this.factors = res.map(e => {
                    return Object({
                        'id': e.bankChartDetailsId,
                        'bankId': e.bankId, 
                        'bankName': e.bankName,
                        'code': e.code,
                        'covenantId': e.covenantId,
                        'name': e.name,
                        'termId': e.termId,
                        'term': e.term,
                        'interest': e.interest,
                        'cet': e.cet,
                        'factor': e.factor,
                        'day': e.day,
                        'today': e.today == 0 ? false : true,
                        'todayFactor': e.today == 0 ? null : e.factor,
                    });
                });
                this.filter();
            },
            filter() {
                this.items = this.factors.filter(el => 
                    (!this.bankId || el.bankId == this.bankId) &&
                    el.covenantId == this.covenantId && 
                    (!this.term || el.term == this.term)
                );
            },
            showDetails(item) {
                this.selectedId = item;
                let objItem = this.factors.find(e => e.id == this.selectedId);
                this.todayFactor = objItem.todayFactor ? objItem.todayFactor.toString().replace('.', ',') : '';
                this.dialog = true;
            },
            async saveDetails() {
                let objItem = this.factors.find(e => e.id == this.selectedId);
                let newItem = Object({
                    termId: objItem.termId,
                    day: moment().format('YYYY-MM-DD'),
                    factor: parseFloat(this.todayFactor.toString().replace(',', '.'))
                });
                
                if (newItem.factor != 0 && newItem.factor != null && newItem.factor != '' &&  !isNaN(newItem.factor)) {
                    if (!objItem.today) {
                        try{
                            await this.$api.dataService.execute('bankChartDetails/create', newItem);
                            this.refreshTerms();
                            this.$notifyUser({
                                message: 'Coeficiente cadastrado!'
                            });
                        }
                        catch(err){
                            this.$notifyUser({
                                type: 'error',
                                message: 'Não foi possível cadastrar o coeficiente!'
                            });

                        }
                    } else {
                        if(newItem.factor != objItem.factor) {
                            try{
                                await this.$api.dataService.execute('bankChartDetails/update', { id: objItem.id, ...newItem });
                                this.refreshTerms();
                                this.$notifyUser({
                                    message: 'Coeficiente editado!'
                                });

                            }
                            catch(err){
                                this.$notifyUser({
                                    type: 'error',
                                    message: 'Não foi possível editar o coeficiente!'
                                });
                            }
                        }
                    }
                } else {
                    this.dialog = false;
                    this.$notifyUser({
                        type: 'error',
                        message: 'Não é possível cadastrar coeficientes nulos!'
                    });
                }
            }
        },

        watch: {
            'bankId' (value) {
                this.filter();
            },
            'covenantId' (value) {
                this.filter();
            },
            'term' (value) {
                this.filter();
            }
        },

        async created() { 
            await this.refreshTerms();
        }
    };
</script>

<style scoped>
    * {
        color: #262626;
    }

    .box-filters {
        display: flex;
        flex-direction: row;
    }

    .filter-banks {
        margin: 0 20px;
    }

    .filter-terms {
        margin-right: 15px;
    }

    .btn-option-group {
        margin: 0 !important;
        margin-top: 5px !important;
        margin-bottom: 25px !important;
    }

    .btn-option {
        width: 100%;
        padding: 10px;
        background-color: #EFEFEF;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 8px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/pages/TodayFactors.vue